import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Upload, File, Database, Check } from "lucide-react";
import { Button } from "@shared/ui/button";
import { useNavigate } from "react-router-dom";

export function DataUploadCard() {
  const navigate = useNavigate();

  return (
    <Card className="relative">
      <CardHeader className="flex flex-row items-center pb-2">
        <CardTitle className="text-md font-medium flex items-center">
          <Upload className="w-4 h-4 mr-2" /> Data Upload
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <p className="text-xs text-muted-foreground mb-2 text-center">
              Simplify your data integration process with our smart tools
            </p>
            <p className="text-xs text-muted-foreground mb-4 text-center">
              Automated recognition, mapping, and validation ensure accuracy
            </p>
          </div>
          <div className="grid grid-cols-3 gap-2">
            <div className="text-center">
              <div className="bg-blue-100 rounded-full w-8 h-8 mx-auto flex items-center justify-center mb-1">
                <File className="w-4 h-4 text-blue-600" />
              </div>
              <p className="text-xs font-medium">Smart Recognition</p>
            </div>

            <div className="text-center">
              <div className="bg-purple-100 rounded-full w-8 h-8 mx-auto flex items-center justify-center mb-1">
                <Database className="w-4 h-4 text-purple-600" />
              </div>
              <p className="text-xs font-medium">Data Mapping</p>
            </div>

            <div className="text-center">
              <div className="bg-green-100 rounded-full w-8 h-8 mx-auto flex items-center justify-center mb-1">
                <Check className="w-4 h-4 text-green-600" />
              </div>
              <p className="text-xs font-medium">Smart Validation</p>
            </div>
          </div>

          <Button
            className="absolute mx-4 bottom-4 left-0 right-0 mt-6"
            onClick={() => navigate("/onboarding/data-migration/data-cards")}
          >
            Go to Data Upload
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
